import * as parts from './parts'

export interface SharedColors {
  PrimaryButton: parts.PrimaryButtonColors
  CancelButton: parts.CancelButtonColors
  CloseButton: parts.CloseButtonColors
  Badge: parts.BadgeColors
  ExtensionBadge: parts.ExtensionBadgeColors
  UnreadDot: parts.UnreadDotColors
  SearchInput: parts.SearchInputColors
  Dropdown: parts.DropdownColors
  Dropzone: parts.DropzoneColors
  FloatingMenu: parts.FloatinMenuColors
  AudioPlayer: parts.AudioPlayerColors
  ScrollingList: parts.ScrollingListColors
  TagInput: parts.TagInputColors
  MangoAlert: parts.MangoAlertColors
  Tooltip: parts.TooltipColors
}

export const sharedColors: SharedColors = {
  PrimaryButton: parts.primaryButtonColors,
  CancelButton: parts.cancelButtonColors,
  CloseButton: parts.closeButtonColors,
  Badge: parts.badgeColors,
  ExtensionBadge: parts.extensionBadgeColors,
  UnreadDot: parts.unreadDotColors,
  SearchInput: parts.searchInputColors,
  Dropdown: parts.dropdownColors,
  Dropzone: parts.dropzoneColors,
  FloatingMenu: parts.floatingMenuColors,
  AudioPlayer: parts.audioPlayerColors,
  ScrollingList: parts.scrollingListColors,
  TagInput: parts.tagInputColors,
  MangoAlert: parts.mangoAlertColors,
  Tooltip: parts.tooltipColors,
}
